import { useEffect, useState } from "react"
import Card from "../../components/Card"
import Header from "../../components/Header"
import Button from "../../components/Button"
import Stack from "../../components/Stack"
import { syncRepOptions, fetchMostRecentRepSync } from "../../api/admin/api"
import FlashMessage from "../../components/FlashMessage"

export default function SyncRepData() {
  const [isSyncing, setIsSyncing] = useState(false)
  const [flashMessage, setFlashMessage] = useState('');
  const [type, setType] = useState('')
  const [lastSync, setLastSync] = useState(null)

  const syncRepOptionsAndWait = async () => {
    try {
      setIsSyncing(true)

      const response = await syncRepOptions()
      if (response.status === "success") {
        fetchMostRecentRepSync().then(res => setLastSync(res.message))
        setType("success")
        setFlashMessage(`Rep data synchronized successfully. ${response.message}`)
      } else {
        setType("error")
        setFlashMessage("Failed to synchronize rep data.")
      }
    } catch (error) {
      setType("error")
      setFlashMessage(`An error occurred while synchronizing rep data. ${error}`)
    } finally {
      setIsSyncing(false)
    }
  }

  useEffect(() => {
    fetchMostRecentRepSync()
      .then(response => {
        setLastSync(response.message)
      })
      .catch((error) => setLastSync(`Failed to fetch last sync time, ${error}`))
  }, [])

  return (
    <Card>
      <FlashMessage
        message={flashMessage}
        type={type}
        onClose={() => {
          setFlashMessage('')
          setType('')
        }}
      />
      <Stack gap="10">
        <Stack gap="4">
          <Header>Sync Rep Data</Header>
          <p className="text-sm"><strong>Last Completed Sync:</strong> {lastSync}</p>
          <p className="text-xs text-gray-700">
            This process will pull data from the 'Options' google sheet & use it to create / update reps inside of this application.
            Once this worker runs successfully, any new rep on the google sheet, should immediately be available as an option when building a team.
            This process may take 1 to 2 minutes to complete. You may leave the page and the process will continue to run until it has completed but
            you will not receive any notification of completion if you leave.
          </p>
        </Stack>

        <Button
          onClickMethod={syncRepOptionsAndWait}
          disabled={isSyncing}
        >
          {isSyncing ? (
            <>
              <span className="spinner" /> Syncing...
            </>
          ) : (
            "Sync"
          )}
        </Button>
      </Stack>
    </Card>
  )
}
